import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EneIconComponent } from "./icon.component";

@NgModule({
  declarations: [EneIconComponent],
  imports: [CommonModule],
  exports: [EneIconComponent]
})
export class EneIconModule {}
